<template>
  <div id="app" class="page">
    <router-view class="content"></router-view>
    <el-backtop></el-backtop>
    <div
      class="float-tip"
      v-if="
          curRoutePath == '/user/proxyRegister/register' ||
          curRoutePath == '/user/proxyRegister/orderConfirm' ||
          curRoutePath == '/user/proxyRegister/paySuccess'
      "
    >
      <el-row type="flex" align="middle" style="height: 100%;" >
        <el-col :span="4" class="p-l-15"><img src="/static/img/mini-logo.png" style="width: 30px;height: 30px;margin-top: 3px;" /></el-col>
        <el-col :span="20" class="p-l-15" align="middle" >
          <p class="font-size-16" v-if="curRoutePath == '/user/proxyRegister/register'"><em>{{$t(actionMap[curRoutePath])}}</em></p>
          <p class="font-size-16" v-if="curRoutePath == '/user/proxyRegister/shopping'"><em>{{$t(actionMap[curRoutePath])}}</em></p>
          <p class="font-size-16" v-if="curRoutePath == '/user/proxyRegister/orderConfirm'"><em>{{$t(actionMap[curRoutePath])}}</em></p>
          <p
            class="font-size-14"
            v-if="curRoutePath == '/user/proxyRegister/shopping' || curRoutePath == '/user/proxyRegister/orderConfirm' || curRoutePath == '/user/proxyRegister/paySuccess'"
          >
            Id:{{ userInfo.proxyUser.userId }}
          </p>
          <p class="font-size-16" v-if="curRoutePath == '/registerShopping'"><em>{{$t(actionMap[curRoutePath])}}</em></p>
          <p class="font-size-16" v-if="curRoutePath == '/registerShopping'">Id:{{ userInfo.userId }}</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'app',
  data() {
    return {
      actionMap:{
        '/user/proxyRegister/register':'8004109',
        //'/user/proxyRegister/shopping':'8004110',
        '/user/proxyRegister/orderConfirm':'8004111',
        //'/registerShopping':'8004096',
      }
    };
  },
  created() {
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('messageStore', JSON.stringify(this.$store.state));
    });

    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))));
  },

  computed: {
    ...mapState(['userInfo', 'curRoutePath'])
  },

  watch: {
    $route(to, from) {
      this.SET_ROUTE_PATH(to.path); //当前路由
      this.toPath = to.path

      if (to.path === '/user/proxyRegister/register') {
        this.userInfo.proxyUser = {};
        this.RECORD_USERINFO(this.userInfo); //更新用户信息
      }
    }
  },

  methods: {
    ...mapMutations(['RECORD_USERINFO', 'GET_USERINFO', 'SET_ROUTE_PATH']),
  }
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import 'assets/style/index.scss';
.el-button--primary {
  min-width: 120px;
}

.el-carousel__button {
     background-color: #06a54e;
 }

.el-message-box__btns {
  button {
    width: 120px;
    border-radius: 0px;
  }
}

.el-carousel__button {
  width: 8px;
  height: 8px;
  border-radius: 8px;
}

.van-sticky--fixed {
  z-index: 20;
}

.content {
  background: #fff;
}

.link-btn {
  color: #409eff;
  padding: 2px 10px;
}

.el-divider__text {
  padding: 0 10px;
  font-size: 14px;
  font-weight: 700;
}

.el-table--mini th,
.el-table--mini td {
  padding: 2px 0;
}

.el-input-group__append,
.el-input-group__prepend {
  padding: 0 5px;
}

.el-badge__content {
  height: 20px;
}

.el-message-box__title {
  span {
    font-size: 16px;
  }
}

.el-popover {
  border-radius: 0px;
  border: 1px solid #ebeef5;
  padding: 12px;
}

.el-breadcrumb__inner {
  font-weight: 400 !important;
  font-size: 13px !important;
}

.float-tip {
  background-color: #f79056;
  font-size: 15px;
  color: #fff;
  height: 50px;
  width: 200px;
  position: fixed;
  top: 50%;
  right: 0%;
  margin-top: -100px;
  margin-left: -100px;
  z-index: 9999;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// App.vue?623c937f